import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Stack,
    Title,
    Text,
    Button,
    Paper,
    Group,
    Card
} from '@mantine/core';
import {
    IconArrowLeft,
    IconCertificate,
    IconClock
} from '@tabler/icons-react';

const Certificate = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/member/dashboard');
    };

    return (
        <Stack gap="md">
            {/* Header with Back Button */}
            <Group>
                <Button
                    variant="light"
                    leftSection={<IconArrowLeft size={16} />}
                    onClick={handleBack}
                >
                    Back to Dashboard
                </Button>
            </Group>

            {/* Main Content */}
            <Paper withBorder p="xl" radius="md">
                <Stack align="center" gap="lg">
                    {/* Icon and Title */}
                    <Group>
                        <IconCertificate size={48} color="var(--mantine-color-blue-6)" />
                        <Title order={2} ta="center">
                            Course Certificate
                        </Title>
                    </Group>

                    {/* Coming Soon Message */}
                    <Card withBorder p="lg" w="100%" maw={500}>
                        <Stack align="center" gap="md">
                            <IconClock size={64} color="var(--mantine-color-blue-6)" />
                            
                            <Title order={3} ta="center" c="blue">
                                Coming Soon!
                            </Title>

                            <Text size="md" ta="center" fw={500}>
                                Certificate feature will be announced in the community.
                            </Text>

                            <Text size="sm" ta="center" c="dimmed">
                                Thank you for your patience!
                            </Text>
                        </Stack>
                    </Card>
                </Stack>
            </Paper>
        </Stack>
    );
};

export default Certificate;